import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getErrorMessage, isNotFoundError } from "../../../api/error";
import { useGetDetailCompany } from "../../../api/company";
import CustomBreadCrumb from "../../../components/breadCrumb/breadCrumb";
import { useNotification } from "../../../components/providers/notification/useNotification";
import { setTitleHeader } from "../../../store/use-title-header-store";
import { useMetadataCountries } from "../../../utils/hooks/useMetadataCountries";
import DetailBank from "./component/detail-bank";
import DetailInfo from "./component/detail-info";
import DetailWallet from "./component/detail-wallet";
import "./detail.css";
import { ButtonMethodCustom } from "../../../components/button/buttonOption";
import useResponsive from "../../../utils/hooks/useResponsive";

const breadCrumbDetail = [
  {
    name: "Portfolio",
    path: "/",
  },
  {
    name: "Beneficiaries & Remitters",
    path: "/beneficiaries",
  },
];

const listTab = [
  {
    name: "Info",
    value: "info",
  },
  {
    name: "Wallets",
    value: "wallet",
  },
  {
    name: "Banks",
    value: "bank",
  },
];

export const ThemedBenificiaryRemitterDetails: React.FC<any> = () => {
  const { isTablet } = useResponsive();
  const navigate = useNavigate();
  const { open: openNotification } = useNotification();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get("tab");
  const [breadCrumb, setBreadCrumb] = useState<any[]>(breadCrumbDetail);
  const [tabActive, setTabActive] = useState<"info" | "bank" | "wallet">(
    (tab as "info" | "bank" | "wallet") || "info"
  );

  const {
    data,
    isLoading,
    isError: isErrorDetailCompany,
    error: errorDetailCompany,
  } = useGetDetailCompany(id ? Number(id) : null);

  const { metadataCountries } = useMetadataCountries();

  useEffect(() => {
    if ((id && isErrorDetailCompany) || !Number(id)) {
      if (isNotFoundError(errorDetailCompany) || !Number(id)) {
        navigate("/404");
      } else {
        openNotification?.({
          key: "company_detail_error",
          message:
            getErrorMessage(errorDetailCompany) ||
            "Failed to load company detail",
          type: "error",
        });
        navigate("/beneficiaries");
      }
    }
  }, [id, isErrorDetailCompany, errorDetailCompany, openNotification, navigate]);

  useEffect(() => {
    if (data && breadCrumb.length < 3) {
      setBreadCrumb([
        ...breadCrumb,
        {
          name: `${data.data.fullName}`,
          path: `/beneficiaries/${id}`,
        },
      ]);
    }
  }, [data]);

  useEffect(() => {
    if (!data) return;
    setTitleHeader(data.data.fullName);
  }, [data]);

  const handleChangeTab = (value: string) => {
    setTabActive(value as "info" | "bank" | "wallet");
    navigate(`/beneficiaries/${id}?tab=${value}`);
  };

  return (
    <div className="history-container">
      <CustomBreadCrumb breadCrumb={breadCrumb} showHome={true} />
      <div className={"frame-detail-v2"}>
        <div className={"frame-detail-left-v2"}>
          {listTab.map((item) => (
            <ButtonMethodCustom
              size={isTablet ? "small" : "medium"}
              key={item.value}
              text={item.name}
              isSelected={tabActive === item.value}
              onClick={() => handleChangeTab(item.value)}
            />
          ))}
        </div>
        <div className={"frame-detail-right-v2"}>
          <DetailInfo
            tabActive={tabActive}
            id={id}
            detailCompany={data?.data}
            isLoadingDetail={isLoading}
            metadataCountries={metadataCountries}
            handleChangeTab={handleChangeTab}
            tabList={[
              {
                name: "Add Wallets",
                value: "wallet",
              },
              {
                name: "Add Banks",
                value: "bank",
              }
            ]}
          />
          <DetailWallet
            tabActive={tabActive}
            id={id}
            userId={data?.data.userId || undefined}
          />
          <DetailBank
            tabActive={tabActive}
            id={id}
            userId={data?.data.userId || undefined}
          />
        </div>
      </div>
    </div>
  );
};
